"use client";
import * as React from "react";
const SvgUnfoldLessRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 17", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.908 16.1c.411.41 1.075.41 1.486 0l2.602-2.603L7.6 16.099a1.05 1.05 0 1 0 1.486-1.485l-3.34-3.34a1.05 1.05 0 0 0-1.486 0l-3.34 3.34a1.04 1.04 0 0 0-.01 1.485ZM9.085.715a1.05 1.05 0 0 0-1.486 0L4.996 3.318 2.394.716a1.05 1.05 0 0 0-1.486 0c-.41.41-.41 1.085 0 1.496l3.34 3.34a1.05 1.05 0 0 0 1.486 0l3.34-3.34a1.05 1.05 0 0 0 .01-1.496Z" }));
export {
  SvgUnfoldLessRound as default
};
